// BlockNameSuggestions — chip-row som föreslår block-namn baserat på
// block.type + connectorKind. Pickas namnet → callback fyller i namn-
// fältet i parent.
//
// Verbatim extract från PropertiesPanel.tsx (POST_QA_SUBPLAN E.1
// cleanup). Ingen logikändring.

import type { WorkflowBlock } from '@/types/workflow';
import { suggestBlockNames } from '@/lib/blockNameSuggestions';
import type { ConnectorKind } from '@/lib/connectorsRegistry';

export function BlockNameSuggestions({
  block,
  onPick,
}: {
  block: WorkflowBlock;
  onPick: (name: string) => void;
}) {
  const connectorKind = (block.config as { connectorKind?: ConnectorKind })?.connectorKind;
  const suggestions = suggestBlockNames({
    block: { type: block.type, config: block.config },
    connectorKind,
  });
  if (suggestions.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1 pt-1" data-testid="block-name-suggestions">
      {suggestions.map((s) => (
        <button
          type="button"
          key={s}
          onClick={() => onPick(s)}
          className="px-2 py-0.5 text-[11px] rounded-md bg-muted/60 hover:bg-muted border border-border/40 text-muted-foreground hover:text-foreground transition-colors"
          data-testid="block-name-suggestion"
        >
          {s}
        </button>
      ))}
    </div>
  );
}
